import React, { useState } from 'react';
import '../App.css';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Heading,
  Box,
  Button,
  Flex,
  Text,
} from '@chakra-ui/react';
import { ResultEventTable } from './components/ResultEventTable';
import { eventListType, eventType } from '../common/types';
import { createForecastData } from './functions/createScoreData';
import { useResultData } from './functions/getData';
import {
  useCPBData,
  useCSBData,
  usePBData,
  useSBData,
} from './request/requests';
import { ResultLink } from './components/ResultLink';
import { dateGame, titleGame } from './components/TitleGame';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon, RepeatIcon } from '@chakra-ui/icons';
import { ResultTableEn } from './components/ResultTableEn';
import { ResultEventTableEn } from './components/ResultEventTableEn';

export const DecathlonResultTableEn = () => {
  const EventList: eventListType = {
    i00: '100m',
    lj: 'LongJump',
    sp: 'ShotPut',
    hj: 'HighJump',
    A00: '400m',
    ii0h: '110mH',
    dt: 'DiscusThrow',
    pv: 'PoleVault',
    jt: 'JavelinThrow',
    i500: '1500m',
  };

  //  papa.parseでスプレッドシートから記録を取得する
  const dataFromSpreadSheet = useResultData();

  const csbDataInitial = useCSBData();
  const cpbDataInitial = useCPBData();
  const sbData = useSBData();
  const pbData = usePBData();

  // const profileData = useProfileData();

  //  現在終了種目時点での予想記録を作成する
  const sbForecastData = dataFromSpreadSheet.map((d, i) =>
    createForecastData(
      d,
      !!csbDataInitial[i] ? csbDataInitial[i] : csbDataInitial[0]
    )
  );
  const pbForecastData = dataFromSpreadSheet.map((d, i) =>
    createForecastData(
      d,
      !!cpbDataInitial[i] ? cpbDataInitial[i] : cpbDataInitial[0]
    )
  );

  const handleUpdate = () => {
    // 更新のロジックを実装する部分
    window.location.reload();

    // ボタンがクリックされたときに実行される関数です
  };

  // タブスライダーの実装
  // const [tabIndex, setTabIndex] = useState(0);
  // const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setTabIndex(parseInt(event.target.value, 10));
  // };
  // const handleTabsChange = (index: number) => {
  //   setTabIndex(index);
  // };

  return (
    <>
      {/* <Box m={'8px'}>
        <Heading as="h4" size="md">
          {dateGame}
          <br />
          {titleGame}
        </Heading>
        <ResultLink />
      </Box> */}
      　World Athletics Championships Tokyo 25 <br />　
      <br />　
      <Button size="md" fontWeight="light" variant="link">
        <Link to={'/dec/en'}>Decathlon Result</Link>
        <ExternalLinkIcon />
      </Button>
      <br />　
      <Button size="md" fontWeight="light" variant="link">
        <Link to={'/hep/en'}> Heptathlon Result</Link>
        <ExternalLinkIcon />
      </Button>
      <br />
      <Flex justify="space-between" mr={4}>
        <Text fontSize={'xs'}>
          <br />　 Click on the player's name to see their records. <br />　
        </Text>
        <Button colorScheme="gray" onClick={handleUpdate} size="xs">
          Reload
          <RepeatIcon />
        </Button>
      </Flex>{' '}
      　Swipe tabs to view more events
      <Tabs
        size="sm"
        variant="soft-rounded"
        colorScheme="green"
        // index={tabIndex}
        // onChange={handleTabsChange}
      >
        <TabList overflowX="auto" whiteSpace="nowrap">
          <Tab>RESULT</Tab>

          <Tab>
            Pred. Rank
            <br />
            (SB)
          </Tab>
          <Tab>
            Pred. Rank
            <br />
            (PB)
          </Tab>
          {Object.values(EventList).map((event, i) => {
            return <Tab key={i}>{event}</Tab>;
          })}
          <Tab>SB Rank</Tab>
          <Tab>PB Rank</Tab>
          <Tab>Potential SB</Tab>
          <Tab>Potential PB</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ResultTableEn
              Data={dataFromSpreadSheet}
              rawData={dataFromSpreadSheet}
              title="Result"
              // profileData={profileData}
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultTableEn
              Data={sbForecastData}
              rawData={dataFromSpreadSheet}
              title="Pred. Rank(SB)"
              // profileData={profileData}
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultTableEn
              Data={pbForecastData}
              rawData={dataFromSpreadSheet}
              title="Pred. Rank(PB)"
              // profileData={profileData}
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          {Object.keys(EventList).map((event, i) => {
            const e = event as eventType;
            return (
              <TabPanel key={i}>
                <ResultEventTableEn
                  Event={e}
                  Data={dataFromSpreadSheet}
                  csbData={csbDataInitial}
                  cpbData={cpbDataInitial}
                  sbData={sbData}
                  pbData={pbData}
                />
              </TabPanel>
            );
          })}
          <TabPanel>
            <ResultTableEn
              Data={csbDataInitial}
              rawData={dataFromSpreadSheet}
              title="SB Rank"
              // profileData={profileData}
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultTableEn
              Data={cpbDataInitial}
              rawData={dataFromSpreadSheet}
              title="PB Rank"
              // profileData={profileData}
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultTableEn
              Data={sbData}
              rawData={dataFromSpreadSheet}
              title="Potential SB"
              // profileData={profileData}
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultTableEn
              Data={pbData}
              rawData={dataFromSpreadSheet}
              title="Potential PB"
              // profileData={profileData}
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
      {/* <Input
        type="range"
        min="0"
        max="12"
        value={tabIndex}
        onChange={handleSliderChange}
        position="fixed"
        bottom="0"
        zIndex="30"
        backgroundColor="white"
      /> */}
    </>
  );
};
